import Vue from 'vue'
import dayjs from 'dayjs'

Vue.filter('currency', value => {
  const exp = /(\d)(?=(\d{3})+(?!\d))/g
  const rep = '$1,'
  return '$ ' + value.toFixed(2).toString().replace(exp, rep)
})

Vue.filter('date', value => {
  return dayjs(value).format('YYYY-MM-DD')
})

Vue.filter('dateEsp', value => {
  return dayjs(value).format('DD-MM-YYYY')
})

Vue.filter('twoDecimals', value => {
  return value.toFixed(2).toLocaleString()
})
